import styled from 'styled-components';
import { colours } from 'themes/default';

const StyledStandardPassengerSelection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const RadioFieldsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 0.5;
  background-color: ${colours.Greyscale.MistGrey};
  padding: 16px;
  margin: 8px 0;
  border-radius: 6px;

  &:nth-child(odd) {
    margin-right: 16px;
  }

  > fieldset {
    width: 100%;

    > legend {
      margin-bottom: 16px;
    }
  }
`;

const StyledDescription = styled.span`
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: 400;
  vertical-align: bottom;
`;

const ErrorMessageContainer = styled.div`
  color: ${colours.Messaging.ErrorRed};
`;

const InfoIcon = styled.span`
  cursor: pointer;
  margin-left: 4px;
  vertical-align: middle;
`;

const TooltipContent = styled.div`
  white-space: pre-line;
  max-width: 300px;
  line-height: 1.5;
  padding: 4px;
  font-weight: normal;
`;

export { ErrorMessageContainer, StyledStandardPassengerSelection, RadioFieldsContainer, StyledDescription, InfoIcon, TooltipContent };
